import { useQuery } from '@tanstack/react-query'
import { getLeadShifts } from 'api/shift'
import { QueryFnParams, QueryOptions } from 'queries/types'
import { leadShiftsKey } from './keys'

export function useLeadShifts(
  params: Partial<QueryFnParams<typeof getLeadShifts>[0]>,
  options: QueryOptions<typeof getLeadShifts> = {}
) {
  const { companyId, shiftId } = params

  return useQuery({
    refetchInterval: 60000, // refresh every 60s, same as the shift detail query
    ...options,
    queryKey: leadShiftsKey(shiftId),
    queryFn: ({ signal }) => {
      if (!companyId || !shiftId) {
        throw new Error('Company and shift are required')
      }
      return getLeadShifts({ companyId, shiftId }, signal)
    },
    enabled: !!companyId && !!shiftId && (options.enabled ?? true),
  })
}
